export enum ProjectTimelineItemType {
	ASSET = "asset",
	ASSET_COMMENT = "asset-comment",
	ASSET_ATTACHMENT = "asset-attachment",
	ASSET_FIELD_VALUES = "asset-field-values",
	ASSET_IDENTIFIER_VALUE = "asset-identifier-value",
	DOCUMENT = "document",
	GEO_IMAGE = "geo-image",
	ISSUE_ASSOCIATION = "issue-association",
	ISSUE_ATTACHMENT = "issue-attachment",
	ISSUE_COMMENT = "issue-comment",
	ISSUE = "issue",
	ISSUE_FIELD_VALUES = "issue-field-values",
	ISSUE_IDENTIFIER_VALUE = "issue-identifier-value",
	ISSUE_UPDATE = "issue-update",
	FORM_SUBMISSION = "form-submission",
	PROCEDURE_INITIATIVE = "procedure-initiative",
	PROCEDURE_FIELD_VALUES = "procedure-field-values",
	PROCEDURE = "procedure",
	PROCEDURE_STEP_COMMENT = "procedure-step-comment",
	PROCEDURE_STEP_FIELD_VALUES = "procedure-step-field-values",
	PROCEDURE_STEP_EVENT = "procedure-step-event",
	PROCEDURE_STEP_REVIEW = "procedure-step-review",
	PROJECT_ATTACHMENT = "project-attachment",
	PROJECT_COMMENT = "project-comment",
}

export enum ProjectTimelineItemTypeGroup {
	ASSETS = "assets",
	DOCUMENTS = "documents",
	GEO_IMAGES = "geo-images",
	ISSUES = "issues",
	FORMS = "forms",
	PROCEDURES = "procedures",
	COMMENTS = "comments",
	ATTACHMENTS = "attachments",
}
